import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "user-calendar" }
const _hoisted_2 = { class: "calendar-card box" }

import { Locale, addMonths, format, subMonths } from 'date-fns'
  import { ComputedRef, computed, ref, toRefs, onBeforeMount } from 'vue'

  import CalendarCells from '@/components/Dashboard/UserCalendar/CalendarCells.vue'
  import CalendarDays from '@/components/Dashboard/UserCalendar/CalendarDays.vue'
  import CalendarHeader from '@/components/Dashboard/UserCalendar/CalendarHeader.vue'
  import { ROOT_STORE, WORKOUTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IAuthUserProfile } from '@/types/user'
  import { IWorkout, TWorkoutsPayload } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { getCalendarStartAndEnd } from '@/utils/dates'
  import { defaultOrder } from '@/utils/workouts'

  interface Props {
    sports: ISport[]
    user: IAuthUserProfile
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    sports: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
    sports: ISport[]
    user: IAuthUserProfile
  }

  

  const store = useStore()

  const { sports, user } = toRefs(props)
  const dateFormat = 'yyyy-MM-dd'
  let day = ref(new Date())
  let calendarDates = ref(getCalendarStartAndEnd(day.value, props.user.weekm))
  const calendarWorkouts: ComputedRef<IWorkout[]> = computed(
    () => store.getters[WORKOUTS_STORE.GETTERS.CALENDAR_WORKOUTS]
  )
  const localeOptions: ComputedRef<Locale> = computed(
    () => store.getters[ROOT_STORE.GETTERS.LOCALE]
  )

  onBeforeMount(() => getCalendarWorkouts())

  function getCalendarWorkouts() {
    calendarDates.value = getCalendarStartAndEnd(day.value, props.user.weekm)
    const apiParams: TWorkoutsPayload = {
      from: format(calendarDates.value.start, dateFormat),
      to: format(calendarDates.value.end, dateFormat),
      page: 1,
      per_page: 100,
      ...defaultOrder,
    }
    store.dispatch(WORKOUTS_STORE.ACTIONS.GET_CALENDAR_WORKOUTS, apiParams)
  }
  function displayNextMonth() {
    day.value = addMonths(day.value, 1)
    getCalendarWorkouts()
  }
  function displayPreviousMonth() {
    day.value = subMonths(day.value, 1)
    getCalendarWorkouts()
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CalendarHeader, {
        day: _unref(day),
        "locale-options": _unref(localeOptions),
        onDisplayNextMonth: displayNextMonth,
        onDisplayPreviousMonth: displayPreviousMonth
      }, null, 8, ["day", "locale-options"]),
      _createVNode(CalendarDays, {
        "start-date": _unref(calendarDates).start,
        "locale-options": _unref(localeOptions)
      }, null, 8, ["start-date", "locale-options"]),
      _createVNode(CalendarCells, {
        currentDay: _unref(day),
        "end-date": _unref(calendarDates).end,
        sports: _unref(sports),
        "start-date": _unref(calendarDates).start,
        timezone: _unref(user).timezone,
        workouts: _unref(calendarWorkouts),
        weekStartingMonday: _unref(user).weekm
      }, null, 8, ["currentDay", "end-date", "sports", "start-date", "timezone", "workouts", "weekStartingMonday"])
    ])
  ]))
}
}

})